/** The reply of POST /api/llm/providers/test (llm_endpoints.test_llm_provider_endpoint). */
export interface ProviderTestResult {
  status: string;
  message: string;
  available?: boolean;
}

/**
 * STORY-437 / BUG-1.6.0_20: a provider test passes only when the backend says
 * success AND the provider is usable. The old gate blocked only when BOTH were
 * negative, so `{status: 'success', available: false}` (an Ollama model that is
 * not pulled) let the provider be added, green until the first chat 404'd.
 * Equivalent mutant: `status !== 'error'` (the endpoint emits only 'success'
 * or 'error').
 * Equivalent mutant: `!!result.available` for `available === true` (the
 * endpoint always sends `available` as a boolean, never another truthy value).
 */
export function providerTestPassed(result: ProviderTestResult): boolean {
  return result.status === 'success' && result.available === true;
}
